import { render } from "./business-profile-tab.vue?vue&type=template&id=706ed6ec&ts=true"
import script from "./business-profile-tab.vue?vue&type=script&lang=ts"
export * from "./business-profile-tab.vue?vue&type=script&lang=ts"

import "./business-profile-tab.vue?vue&type=style&index=0&id=706ed6ec&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__